export default __webpack_public_path__ + "static/media/mon_24.06b182af.png";